import { useQuery } from "@apollo/client";
import { getActivityTypeNavLinks } from "@/pages/activities/activity-types/[activityTypeId]/_utils";
import { GET_ACTIVITY_TYPE } from "@/pages/activities/activity-types/queries";
import MobileNavigation from "./MobileNavigation";

export interface MobileActivityTypeNavigationProps {
  activityTypeId: string;
}

export default function MobileActivityTypeNavigation({ activityTypeId }: MobileActivityTypeNavigationProps) {
  const { data } = useQuery(GET_ACTIVITY_TYPE, { variables: { id: activityTypeId } });
  const activityTypeTitle = data?.activityType?.title;

  const allNavLinks = getActivityTypeNavLinks(activityTypeId, activityTypeTitle);

  const navLinks = {
    ...allNavLinks,
    "Manage Activity Type": (allNavLinks["Manage Activity Type"] || []).filter((link) => !link.externalLink)
  };

  return <MobileNavigation links={navLinks} section="Manage Activity Type" testId="mobile-activity-type-navigation" />;
}
